import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

class MultipleQualificationSelect extends React.Component {


    handleChange = event => {
        const { onChange, selected } = this.props;

        if (selected.length === 0) {
            event.target.value = event.target.value.filter(x => x !== -1);
        }
        else {
            if (event.target.value.indexOf(-1) > -1) {
                event.target.value = [];
            }
        }
        
        onChange(event);
    };

    handleSelectAllInCategory = (categorieId, event) => {
        event.stopPropagation();
        const { onChange, selected, categoriesQualifications } = this.props;
        
        // Trouver la catégorie correspondante
        const categorie = categoriesQualifications.find(cat => cat.libelle === categorieId);
        
        if (!categorie) return;
        
        // Récupérer tous les IDs de qualification de cette catégorie
        const categoryQualificationIds = categorie.qualifications.map(qual => qual.id);
        
        // Créer un nouvel array avec les qualifications déjà sélectionnées
        // et ajouter celles de la catégorie qui ne sont pas encore sélectionnées
        let newSelection = [...selected];
        
        // Si -1 (Toutes) est sélectionné, on commence avec un tableau vide
        if (newSelection.includes(-1)) {
            newSelection = [];
        }
        
        // Ajouter les qualifications de la catégorie qui ne sont pas déjà sélectionnées
        categoryQualificationIds.forEach(id => {
            if (!newSelection.includes(id)) {
                newSelection.push(id);
            }
        });
        
        // Créer un événement synthétique pour utiliser handleChange
        const syntheticEvent = {
            target: {
                name: "qualificationIds",
                value: newSelection
            }
        };
        
        onChange(syntheticEvent);
    };

    handleDeselectAllInCategory = (categorieId, event) => {
        event.stopPropagation();
        const { onChange, selected, categoriesQualifications } = this.props;
        
        // Trouver la catégorie correspondante
        const categorie = categoriesQualifications.find(cat => cat.libelle === categorieId);
        
        if (!categorie) return;
        
        // Récupérer tous les IDs de qualification de cette catégorie
        const categoryQualificationIds = categorie.qualifications.map(qual => qual.id);
        
        // Si -1 (Toutes) est sélectionné, on commence avec un tableau vide
        let newSelection = selected.includes(-1) ? [] : [...selected];
        
        // Filtrer pour enlever toutes les qualifications de cette catégorie
        newSelection = newSelection.filter(id => !categoryQualificationIds.includes(id));
        
        // Si la nouvelle sélection est vide, on sélectionne "Toutes"
        if (newSelection.length === 0) {
            newSelection = [-1];
        }
        
        // Créer un événement synthétique pour utiliser handleChange
        const syntheticEvent = {
            target: {
                name: "qualificationIds",
                value: newSelection
            }
        };
        
        onChange(syntheticEvent);
    };

    isCategoryPartiallySelected = (categorie, computedSelection) => {
        const categoryQualificationIds = categorie.qualifications.map(qual => qual.id);
        const selectedInCategory = categoryQualificationIds.filter(id => computedSelection.includes(id));
        
        return selectedInCategory.length > 0 && selectedInCategory.length < categoryQualificationIds.length;
    };

    isCategoryFullySelected = (categorie, computedSelection) => {
        const categoryQualificationIds = categorie.qualifications.map(qual => qual.id);
        return categoryQualificationIds.every(id => computedSelection.includes(id));
    };

    render() {
        const { selected, categoriesQualifications, size } = this.props;
        
        let computedSelection = selected.filter(x => x !== -1);

        let renderValue = "Toutes";
        if (computedSelection.length === 0) {
            computedSelection = [-1];
        }
        else {
            var qualification = undefined;
            renderValue = '';

            categoriesQualifications.forEach(categorie => {
                qualification = categorie.qualifications.find(x => x.id === computedSelection[0]);
                if (qualification !== undefined) {
                    renderValue = qualification.libelle;
                }
            });

            if (computedSelection.length > 1) {
                renderValue += ' +' + (computedSelection.length - 1);
            }
        }

        return (

            <TextField
                id={"qualificationIds"}
                name={"qualificationIds"}
                label={"Qualification(s)"}
                fullWidth
                size={size}
                select
                SelectProps={{
                    multiple: true,
                    value: computedSelection,
                    onChange: this.handleChange,
                    renderValue: () => {
                        return (<div>{renderValue}</div>);
                    }
                }}
                >                
                    <MenuItem key={"-1"} value={-1}>

                        <Radio checked={computedSelection.indexOf(-1) >= 0} />
                        <ListItemText primary="Toutes" />
                    </MenuItem>

                    <ListSubheader key={"-2"} disableSticky>Sélectionner une ou plusieurs qualifications</ListSubheader>

                    {categoriesQualifications.map((categorie) => {
                        const isPartiallySelected = this.isCategoryPartiallySelected(categorie, computedSelection);
                        const isFullySelected = this.isCategoryFullySelected(categorie, computedSelection);
                        
                        return [
                            <ListSubheader
                                key={categorie.libelle}
                                disableSticky
                                color="primary"
                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            >
                                <span>{categorie.libelle}</span>
                                <div>
                                    <Tooltip title="Sélectionner toutes les qualifications de cette catégorie">
                                        <span>
                                            <IconButton
                                                size="small"
                                                onClick={(e) => this.handleSelectAllInCategory(categorie.libelle, e)}
                                                style={{ padding: '2px' }}
                                                disabled={isFullySelected}
                                            >
                                                <PlaylistAddCheckIcon
                                                    fontSize="small"
                                                    color={!isFullySelected ? "secondary" : "disabled"}
                                                />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Tooltip title="Désélectionner toutes les qualifications de cette catégorie">
                                        <span>
                                            <IconButton
                                                size="small"
                                                onClick={(e) => this.handleDeselectAllInCategory(categorie.libelle, e)}
                                                style={{ padding: '2px' }}
                                                disabled={!(isPartiallySelected || isFullySelected)}
                                            >
                                                <ClearAllIcon
                                                    fontSize="small"
                                                    color={(isPartiallySelected || isFullySelected) ? "secondary" : "disabled"}
                                                />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </div>
                            </ListSubheader>,
                            categorie.qualifications.map((qualification) => (
                                <MenuItem key={qualification.id} value={qualification.id}>
                                    <Checkbox checked={computedSelection.indexOf(qualification.id) >= 0} />
                                    <ListItemText primary={qualification.libelle} />
                                </MenuItem>
                            ))
                        ];
                    }).flat(1)}

            </TextField>
        );
    }
}

MultipleQualificationSelect.propTypes = {
    selected: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    size: PropTypes.string
};

export default MultipleQualificationSelect;